let state = {
  paymentOptions: [],
  paymentMethods: [],
  userPromotionV3: [],
  categoriesDashboard: [],
  paymentRequest: {
    type: '',
    amount: 0,
    deviceType: 'WEB',
    paymentMethod: '',
    productFlow: 'epaylater',
    loyaltyPointsSelected: undefined
  },
  payableAmount: undefined,
  merchants: []
}
export default state



// WEBPACK FOOTER //
// ./src/store/eplNewDashboard/state.js